import Vue from "vue";

Vue.directive("scroll", {
    inserted: function(el, binding) {
        let f = function(evt) {
            binding.value(evt, el);
            if (binding.modifiers.once) {
                window.removeEventListener("scroll", f);
            }
        };
        window.addEventListener("scroll", f);
    },
});

function elementInViewport(el, offset = 0) {
    const { top, bottom } = el.getBoundingClientRect();
    const vHeight = window.innerHeight || document.documentElement.clientHeight;
    return (top + offset > 0 || bottom > 0) && top + offset < vHeight;
}

Vue.directive("in-viewport", {
    inserted: function(el, binding) {
        let f = function(evt) {
            var offset = parseInt(binding.arg) || 0;
            var disabled = false;
            let handler;
            if (binding.value instanceof Function) {
                handler = binding.value;
            } else {
                disabled = binding.value.disabled();
                handler = binding.value.handler;
            }

            if (!disabled) {
                if (elementInViewport(el, offset)) {
                    handler(evt, el);
                    if (binding.modifiers.once) {
                        window.removeEventListener("scroll", f);
                    }
                }
            }
        };

        window.addEventListener("scroll", f);
    },
});
